/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import React, {
    useCallback, useEffect, useMemo, useContext
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useValidation } from '@xengage/gw-portals-validation-react'
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import metadata from './DriverAssignmentComponent.metadata.json5';
import messages from './DriverAssignmentComponent.messages';
import styles from './DriverAssignmentComponent.module.scss';
import { Link } from '@jutro/router';

import { DropdownSelectField, Icon } from '@jutro/legacy/components';

import { TranslatorContext } from '@jutro/legacy/locale';

function DriverAssignmentComponent(props) {

    const retiredDriverAssignments = [
        {code: 'Unlisted', name: 'Unlisted'},
        {code: 'NotRated', name: 'Not Rated'},
        {code: 'Secondary', name: 'Secondary'},
    ]

    const {
        data: vehicleDriversVM,
        index: vehicleIndex,
        onValidate,
        updateWizardData,
        submissionVM,
        vehcileDriverPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    // const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
   const addVehicleDriver = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            vehicleDriversVM.value = vehicleDriversVM.value || []

            const { _xCenter, _dtoName } = vehicleDriversVM;

            const vehicleDriverObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            vehicleDriversVM.pushElement(
                vehicleDriverObjVM
            );

           const assignedDrivers = _.get(submissionVM.value, 'lobData.recVehLine.coverables.vehLocRisks[0].assRisks');

           if (assignedDrivers.length === 1) {

               const availableValues = submissionVM.value.lobData.recVehLine.exposures.prvdriExposures.map((driver) => ({
                   code: `${driver.displayName}`,
                   isPolicyHolder: `${driver.isPolicyHolder}`
               }));

               if (availableValues.length > 0) {
                   const primaryDriver = availableValues?.filter(val => val.isPolicyHolder === 'true');
                   _.set(submissionVM.value, 'lobData.recVehLine.coverables.vehLocRisks[0].assRisks[0].prvdriver', primaryDriver[0]?.code);
               }

               _.set(submissionVM.value, 'lobData.recVehLine.coverables.vehLocRisks[0].assRisks[0].driAss', 'Principal');
           } else {
               _.set(submissionVM.value, `lobData.recVehLine.coverables.vehLocRisks[0].assRisks[${assignedDrivers.length - 1}].driAss`, 'Secondary');
           }

            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, vehicleDriversVM, viewModelService]
    );


    // eslint-disable-next-line @typescript-eslint/no-empty-function
    useEffect(() => {
        
    }, [ ]);

    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );
    
    const addAssignedDriver = useCallback(
        (val, changedPath, assRiskIndex) => {
            const {
                index
            } = props;
        const assignedDriver = submissionVM.value.lobData.recVehLine.exposures.prvdriExposures.find((driver) => {
            return driver.displayName === val;
        })
        _.set(submissionVM.value, `lobData.recVehLine.coverables.vehLocRisks.children.${index}.assRisks.children.${assRiskIndex}.prvdriver`, assignedDriver.displayName);           
        _.set(submissionVM, `lobData.recVehLine.coverables.vehLocRisks.children.${index}.assRisks.children.${assRiskIndex}.prvdriverFixedID.value`, assignedDriver.fixedId); 
        updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );
    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }
            
            vehicleDriversVM.value.splice(index, 1);
            _.set(submissionVM.value, vehcileDriverPath, vehicleDriversVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, vehcileDriverPath, vehicleDriversVM.value]
    );

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;
            

            if (path === 'driverContact') {
                
                const availableValues = submissionVM.value.lobData.recVehLine.exposures.prvdriExposures.map((driver) => ({
                    code: `${driver.displayName}`,
                    name: `${driver.displayName}`
                    }));

                const value = item.prvdriver ? item.prvdriver : '';

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.prvdriver = val;
                            addAssignedDriver(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }
    
            if (path === 'driverType') {
                const value = (item && item.driAss) ? item.driAss : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = vehicleDriversVM.length>0 && vehicleDriversVM.children[index].driAss
                    // eslint-disable-next-line security/detect-object-injection
                    ? [...vehicleDriversVM.children[index].driAss.aspects.availableValues, ...retiredDriverAssignments]
                        .map((typeCode) => ({
                                code: typeCode.code,
                                name: translator({
                                    id: typeCode.name,
                                    defaultMessage: typeCode.name
                                })
                            }))
                    : [];

                    return (
                        <DropdownSelectField
                            id={index + path}
                            className={styles.coverageForm}
                            onValueChange={(val, changedPath) => {
                                item.driAss = val;
                                handleValueChange(val, changedPath, index);
                            }}
                            dataType="string"
                            path={path}
                            value={value}
                            availableValues={availableValues}
                            searchable
                        />
                    );
            }   
        },
        [handleValueChange, translator, vehicleDriversVM?.children, vehicleDriversVM?.length, vehicleDriversVM?.value]
    );

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
                <Link
                    onClick={(e) => removeAssignmentItem(e, index, item)}
                    className={classNames(styles.deleteSection, styles.deleteRow)}
                >
                    <Icon icon="mi-delete" className={styles.deleteIcon} />
                </Link>
            ),
        [removeAssignmentItem]
    );



     
    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`driverAssignmentTable`]: {
            data: vehicleDriversVM.value,
        }
        
    }), [vehicleDriversVM.value])

    const resolvers = {
        resolveCallbackMap: {
            addVehicleDriver,
            getTableCell,
            removeAssignmentTableRow
        }
    };


    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
                metadata.pageContent,
                vehicleDriversVM,
                fieldId,
                fieldPath,
                overrideProps
            ),
        [vehicleDriversVM, overrideProps]
    );

    return (
        <ViewModelForm            
            uiProps={metadata.pageContent}
            model={vehicleDriversVM}
            overrideProps={overrideProps}
           // onValidationChange={setComponentValidation}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

DriverAssignmentComponent.propTypes = {
    data: PropTypes.shape({}),
    labelPosition: PropTypes.string,
    onValidate: PropTypes.func.isRequired,
    updateWizardData: PropTypes.func.isRequired,
    index: PropTypes.string,
    id: PropTypes.string.isRequired,
    submissionVM: PropTypes.shape({}),
    vehicleID: PropTypes.string
};
DriverAssignmentComponent.defaultProps = {
    data: {},
    labelPosition: 'left',
    index: 0,
    submissionVM: {},
    vehicleID: null
};
export default DriverAssignmentComponent;
